export type NumberInputOptions = {
    min?: number;
    max?: number;
    step?: number;
    required?: boolean;
    decimals?: number;
    mousewheel?: boolean;
    hideButtons?: boolean;
    buttondown_class?: string;
    buttonup_class?: string;
    verticalbuttons?: boolean;
    verticalup?: string;
    verticaldown?: string;
};

export class NumberInput {
    private $input: JQuery;
    public onChange?: { (value: number | undefined) };
    private isFloating: boolean = false;
    private config: NumberInputOptions;

    constructor($input?: JQuery, cfg?: NumberInputOptions) {
        this.$input = $input === undefined ? $('<input type="text" class="form-control" />') : $input;
        this.$input.addClass("number-input-control");

        this.config = {
            min: 1,
            max: Number.MAX_SAFE_INTEGER,
            step: 1,
            buttondown_class: "btn btn-secondary",
            buttonup_class: "btn btn-secondary",
            verticalbuttons: true,
            verticalup: '<i class="la la-plus"></i>',
            verticaldown: '<i class="la la-minus"></i>',
            mousewheel: false,
            hideButtons: false,
        };
        this.config = { ...this.config, ...cfg };

        if (this.config.decimals !== undefined && this.config.decimals > 0) {
            this.isFloating = true;
        }
        if (this.config.hideButtons === true) {
            this.$input.addClass("btn-hidden");
        }

        this.$input["TouchSpin"](this.config);
        this.$input.change(() => {
            if (this.onChange !== undefined) this.onChange(this.getValue());
        });
    }

    public getValue(): number | undefined {
        return this.$input.val().length !== 0
            ? this.isFloating
                ? parseFloat(this.$input.val())
                : parseInt(this.$input.val())
            : undefined;
    }

    public setValue(value?: number | string): NumberInput {
        if (this.isFloating && value !== undefined && typeof value == "number") {
            const multiplier = Math.pow(10, this.config.decimals!);
            value = (Math.round(value * multiplier) / multiplier).toFixed(this.config.decimals);
        }

        this.$input.val(value === undefined ? "" : value);
        return this;
    }

    // e.g. a price that takes more decimals while its article is priced per minute. TouchSpin rounds the value to its decimals
    // when it changes, so it is told as well
    public setDecimals(decimals: number): NumberInput {
        this.config.decimals = decimals;
        this.config.step = Math.pow(10, -decimals);
        this.isFloating = decimals > 0;
        this.$input.trigger("touchspin.updatesettings", { decimals: decimals, step: this.config.step });

        return this;
    }

    public setError(hasError: boolean): NumberInput {
        if (hasError) this.$input.addClass("is-invalid");
        else this.$input.removeClass("is-invalid");

        return this;
    }

    public setDisabled(isDisabled: boolean, hideValueWhenDisabled: boolean = false): NumberInput {
        this.$input.prop("disabled", isDisabled);

        if (isDisabled && hideValueWhenDisabled) {
            this.$input.css("color", "transparent");
        } else {
            this.$input.css("color", "#495057");
        }

        return this;
    }

    public setVisible(isVisible: boolean): NumberInput {
        if (isVisible) {
            this.$input.show();
        } else {
            this.$input.hide();
        }

        return this;
    }

    public destroy() {
        this.$input["TouchSpin"]("destroy");
    }

    public renderTo($element: JQuery): NumberInput {
        this.$input.appendTo($element);
        return this;
    }
}
